import addressImg from "../../assests/images/contactus/address.jpg";
import addressBackImg from "../../assests/images/contactus/Pratapgad_fort.jpg";

function ContactUs() {
  const contents = (
    <div className="Row">
      <div
        className="Cell"
        style={{
          textAlign: "left",
          verticalAlign: "top",
          backgroundImage: `url(${addressBackImg})`,
          border: "3px solid #fe6902",
          borderRadius: "40px",
          paddingTop: "20px",
          height: "440px",
        }}
      >
        <div style={{ paddingLeft: "10px", color: "black", fontSize: "20px" }}>
          <h2>
            <font size="25em">
              <strong>मराठा हितवर्धक मंडळ, डोंबिवली</strong>
            </font>
          </h2>
          <font size="20em">
            मराठा मंदिर, महात्मा फुले रोड,
            <br />
            डोंबिवली (प.)
            <br />
            दूरध्वनी क्र. २४०४३८३
            <br />
            भ्रमणध्वनी क्र. ९६१९४४१९५३
            <br />
            Email : marathahitwardhak@gmail.com
          </font>
        </div>
        <div className="Cell">
          {/* <img src={addressImg} border="2px" /> */}
        </div>
      </div>
    </div>
  );

  return contents;
}

export default ContactUs;
